const isShown = {
    XN: 3,
    N: 4,
};

export default isShown;



// WEBPACK FOOTER //
// ./src/js/shared/nav/helpers/isShown.js